// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import styled from 'styled-components';

import { Interval } from 'statsradio/domain/reach';
import { PrimaryButton } from 'statsradio/components/ui/forms/ButtonInput';
import DateRange from 'common/domain/DateRange';
import TimeRangePickerInput from './TimeRangePickerInput';
import TimeIntervalPicker from './TimeIntervalPicker';
import { MetricsQuery } from '../../../domain/Metrics';
import DateRangePopover from './DateRangePopover';
import type { DateRangePeriod } from '../../../domain/MetricsPeriods';

const SForm = styled.form`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  
  >:not(:last-child) {
    margin-right: ${props => props.theme.V3.metrics.margin.normal}px;  
  }
`;

const Submit = styled(PrimaryButton)`
  width: 120px;
`;

interface Props {
  query: MetricsQuery;
  onChange: (query: MetricsQuery) => void;

  t: any;
}

interface State {
  query: MetricsQuery;
  period: DateRangePeriod;
}

class MetricsParameters extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = { query: props.query, period: 'FULL_WEEK' };
  }

  onDateRangesChange = (dateRange: DateRange, dateRangeCompared: DateRange | void) => {
    const query = this.state.query.with({ dateRange, dateRangeCompared });
    this.setState({ query });
  };

  onPeriodChange = (period: DateRangePeriod) => {
    this.setState({ period });
  };

  onTimeIntervalChange = (interval: Interval) => {
    const query = this.state.query.with({ interval });
    this.setState({ query });
  };

  onSubmit = (event: SyntheticEvent<HTMLFormElement>) => {
    event.stopPropagation();
    event.preventDefault();

    this.props.onChange(this.state.query);
  };

  render() {
    const { t } = this.props;
    const { query, period } = this.state;

    return (
      <SForm onSubmit={this.onSubmit}>
        <DateRangePopover
          defaultDateRange={query.dateRange}
          defaultDateRangeCompared={query.dateRangeCompared}
          defaultPeriod={period}
          onDateRangesChange={this.onDateRangesChange}
          onPeriodChange={this.onPeriodChange}
        />
        <TimeRangePickerInput
          timeInterval={query.interval}
          onChange={this.onTimeIntervalChange}
        />
        <TimeIntervalPicker
          timeInterval={query.interval}
          onChange={this.onTimeIntervalChange}
        />
        <Submit type="submit" value={t('apply')} />
      </SForm>
    );
  }
}

export default translate('metrics')(MetricsParameters);



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/v2/components/parameters/MetricsParameters.js